

export default function mirrages() : any[] {
    return [
        {
            image0: {
                "position": {
                    "top" : 20,
                    "left": 1,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -8 
                },
            },
            image1: {
                "position": {
                    "top" : 1,
                    "left": 195,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 0
                },
            },
            image2: {
                "position": {
                    "top" : 10,
                    "left": 390,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 6 
                },
            },
            image3: {
                "position": {
                    "top" : 40,
                    "left": 580,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 13
                },
            },
            
            image4: {
                "position": {
                    "top" : 95,
                    "left": 765,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 19
                },
            },
            image5: {
                "position": {
                    "top" : 194,
                    "left": 345,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 11 
                },
            },
            image6: {
                "position": {
                    "top" : 240,
                    "left": 530,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 18
                },
            },
            image7: {
                "position": {
                    "top" : 320,
                    "left": 700,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 30
                },
            },
            image8: {
                "position": {
                    "top" : 410,
                    "left": 410,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 11
                },
            },
            image9: {
                "position": {
                    "top" : 490,
                    "left": 575,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 35
                },
            },
            text: {
                position: {
                    "top" : 215,
                    "left": 35,
                    "width": 300,
                    "height": 475,
                    "opacity": 1 
                },
            },
        },
        {
            image0: {
                "position": {
                    "top" : 10,
                    "left": 390,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 6
                },
            },
            image1: {
                "position": {
                    "top" : 40,
                    "left": 580,
                    "rotate1": 3,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 13
                },
            },
            image2: {
                "position": {
                    "top" : 95,
                    "left": 765,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 19
                },
            },
            image3: {
                "position": {
                    "top" : 194,
                    "left": 345,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 11
                },
            },
            image4: {
                "position": {
                    "top" : 240,
                    "left": 530,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 18
                },
            },
            image5: {
                "position": {
                    "top" : 320,
                    "left": 700,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 30 
                },
            },
            image6: {
                "position": {
                    "top" : 430,
                    "left": 220,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -6
                },
            },
            image7: {
                "position": {
                    "top" : 470,
                    "left": 25,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -17
                },
            },
            image8: {
                "position": {
                    "top" : 420,
                    "left": 420,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 2
                },
            },
            image9: {
                "position": {
                    "top" : 450,
                    "left": 615,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 16
                },
            }, 
            text: {
                position: {
                    "top" : 1,
                    "left": 35,
                    "width": 300,
                    "height": 475,
                    "opacity": 1 
                },
            }
        },
        {
            image0: {
                "position": {
                    "top" : 120,
                    "left": 1,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -18
                },
            },
            image1: {
                "position": {
                    "top" : 70,
                    "left": 195,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -10
                },
            },
            image2: {
                "position": {
                    "top" : 55,
                    "left": 390,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 0
                },
            },               
            image3: {
                "position": {
                    "top" : 65,
                    "left": 580,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 7
                },
            },
            image4: {
                "position": {
                    "top" : 110,
                    "left": 770,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": 17
                },
            },
            image5: {
                "position": {
                    "top" : 360,
                    "left": 1,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -28
                },
            },
            image6: {
                "position": {
                    "top" : 285,
                    "left": 180,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -17
                },
            },
            image7: {
                "position": {
                    "top" : 245,
                    "left": 370,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -8
                },
            },
            image8: {
                "position": {
                    "top" : 500,
                    "left": 190,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -29
                },
            },
            image9: {
                "position": {
                    "top" : 440,
                    "left": 370,
                    "width": 190,
                    "height": 190,
                    "opacity": 1,
                    "rotate": -11
                },
            },
            text: {
                    "position": {
                        "top" : 330,
                        "left": 580,
                        "width": 330,
                        "height": 520,
                        "opacity": 1 
                    },
                },
        }
    ]
}